import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import "./TraitementDeuxiemeLigne.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import { API_BASE } from "../../config/api";
import noImage from "../../assets/no-image.svg";
const RUBRIQUE = "traitement_deuxieme_ligne";

const MenuBar = ({ editor }) => {
  if (!editor) return null;

  const buttons = [
    { label: "G",       title: "Gras",           action: () => editor.chain().focus().toggleBold().run(),                  active: editor.isActive("bold"),           style: { fontWeight: "bold" } },
    { label: "I",       title: "Italique",        action: () => editor.chain().focus().toggleItalic().run(),                active: editor.isActive("italic"),         style: { fontStyle: "italic" } },
    { label: "S",       title: "Barré",           action: () => editor.chain().focus().toggleStrike().run(),                active: editor.isActive("strike"),         style: { textDecoration: "line-through" } },
    { label: "U",       title: "Souligné",        action: () => editor.chain().focus().toggleUnderline().run(),             active: editor.isActive("underline"),      style: { textDecoration: "underline" } },
    { label: "H1",      title: "Titre 1",         action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),   active: editor.isActive("heading", { level: 1 }) },
    { label: "H2",      title: "Titre 2",         action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),   active: editor.isActive("heading", { level: 2 }) },
    { label: "• List",  title: "Liste à puces",   action: () => editor.chain().focus().toggleBulletList().run(),            active: editor.isActive("bulletList") },
    { label: "1. List", title: "Liste numérotée", action: () => editor.chain().focus().toggleOrderedList().run(),           active: editor.isActive("orderedList") },
    { label: "❝",       title: "Citation",        action: () => editor.chain().focus().toggleBlockquote().run(),            active: editor.isActive("blockquote") },
    { label: "—",       title: "Séparateur",      action: () => editor.chain().focus().setHorizontalRule().run(),           active: false },
    { label: "↩",       title: "Annuler",         action: () => editor.chain().focus().undo().run(),                       active: false },
    { label: "↪",       title: "Rétablir",        action: () => editor.chain().focus().redo().run(),                       active: false },
  ];

  return (
    <div className="tdl-menubar">
      {buttons.map((btn, i) => (
        <button
          key={i}
          title={btn.title}
          className={`tdl-menubar-btn ${btn.active ? "tdl-menubar-btn--active" : ""}`}
          style={btn.style || {}}
          onClick={btn.action}
          type="button"
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};

const TraitementDeuxiemeLigne = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();
  const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
  const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedData = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.data || "");
  const [saving, setSaving] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const contentRef = useRef(savedData || "");

    const editor = useEditor({
    extensions: [StarterKit],
    content: savedData || "",
    onUpdate: ({ editor }) => {
        contentRef.current = editor.getHTML();
    },
    });

  useEffect(() => {
    if (editor && savedData) {
      editor.commands.setContent(savedData);
    }
  }, [id]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);
  const handleSave = () => {
   
    dispatch(updateFormData(id, RUBRIQUE, "data", contentRef.current));
  };

    useEffect(() => {
      return () => {
        handleSave();
      };
    }, []);

    const handleSaveAll = async () => {
        setSaving(true);
     if (!editor) return;
    const html = editor.getHTML();
    dispatch(updateFormData(id, RUBRIQUE, "data", html));
    try {
        const result = await dispatch(saveDossier());
        toast.success(result.message);
        navigate("/");
    } catch (err) {
        toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
    }
    finally {
    setSaving(false);
  }
  };

  const handleCancel = () => {
    if (editor) editor.commands.setContent(savedData || "");
  };

  if (!dossier) {
    return (
      <div className="tdl-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  return (
    <div className="tdl-page">
         {saving && <SaveLoader />}
      {/* ── Header ── */}
      <header className="tdl-header">
        <div className="tdl-header-left">
          <button className="tdl-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="tdl-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="tdl-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="tdl-save-btn" onClick={handleSaveAll} disabled={saving}>Sauvegarder les modifications</button>
      </header>

      <div className="tdl-body">
        {/* ── Colonne gauche : image ── */}
        <aside className="tdl-image-panel">
          <div className="tdl-image-header">
            <span className="tdl-rubrique-label">Traitement de Deuxième Ligne</span>
            <span className="tdl-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="tdl-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="tdl-image" />
          </div>
          <div className="tdl-image-nav">
            <button className="tdl-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
            <div className="tdl-image-dots">
              {IMAGES.map((_, i) => (
                <span key={i} className={`tdl-dot ${i === imgIndex ? "tdl-dot--active" : ""}`} onClick={() => setImgIndex(i)} />
              ))}
            </div>
            <button className="tdl-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
          </div>
        </aside>

        {/* ── Colonne droite : formulaire ── */}
        <main className="tdl-form-panel">
          <div className="tdl-form-scroll">

            <div className="tdl-description">
              <h2 className="tdl-description-title">Traitement de Deuxième Ligne</h2>
              <p className="tdl-description-text">
                Précisez le traitement de deuxième ligne administré au patient, incluant l'état clinique, les interventions effectuées et l'évolution observée.
              </p>
            </div>

            <div className="tdl-editor-wrapper">
              <MenuBar editor={editor} />
              <EditorContent editor={editor} className="tdl-editor" />
            </div>

          </div>

          {/* ── Actions ── */}
          {/* <div className="tdl-form-actions">
            <button className="tdl-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="tdl-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default TraitementDeuxiemeLigne;